module.exports = __webpack_public_path__ + "img/gift.d27caad6.png";